/* eslint-disable react/display-name */
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Avatar,
  Box,
  Divider,
  HStack,
  Heading,
  IconButton,
  SeeMore,
  Stack,
  Text,
  Button,
  Tooltip,
} from '@mybridge/ui';
import React, { forwardRef, useContext, useEffect, useMemo, useState, useRef } from 'react';
import { EditIcon } from '@mybridge/icons/Edit';
import { MyProfileContext } from '../context';
import moment from 'moment';
import { EMPLOYMENT_CHOICES } from 'v4/lib/data';
import { ShowAllLink } from '../show-all-link';
import { formatCommaSeparated } from 'v4/lib/commons';
import {
  EarthGlobeIcon,
  TeamIcon,
  OnlyMeLockIcon,
  AddCircleFIlled,
  NewPlusIcon
} from '@mybridge/icons';
import { MyProfileExperienceModal } from '../experience-modal';
import { AddIcon } from '@chakra-ui/icons';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';

export const MyProfileExperience = React.memo(forwardRef(({ ...props }, ref) => {
  const {
    experienceDisc,
    myExperiences,
    refetchMyExperiences,
    setSelectedExperience,
    audienceDisc,
    setPermissionValue,
    setPermissionId,
    setCurrentPermissionValue,
  } = useContext(MyProfileContext);
  const { t } = useTranslator();
  const [showAll, setShowAll] = useState(false);
  const router = useRouter();
  const sectionRef = useRef(null);

  useEffect(() => {
    refetchMyExperiences?.();
  }, []);

  useEffect(() => {
    if (router.query.openDisc === 'experience') {
      setSelectedExperience(null);
      experienceDisc?.onOpen?.();
      
      router.replace(router.pathname, undefined, { shallow: true });
    }
    
    if (router.query.scrollTo === 'experience' && sectionRef.current) {
      const elementRect = sectionRef.current.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);
      
      window.scrollTo({
        top: middle,
        behavior: 'smooth'
      });
      
      const { scrollTo, ...rest } = router.query;
      router.replace(
        { pathname: router.pathname, query: rest },
        undefined,
        { shallow: true }
      );
    }
  }, [router.query, experienceDisc, setSelectedExperience]);

  const onEditClick = (exp) => (e) => {
    setSelectedExperience(exp);
    experienceDisc?.onOpen?.();
  };

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
    }
  };

  const groupedExperiences = useMemo(() => {
    const myExps = {};
    if (!Array.isArray(myExperiences)) return;
    for (let me of myExperiences) {
      if (myExps?.[me?.company_name]) {
        myExps[me.company_name].push(me);
      } else {
        myExps[me.company_name] = [me];
      }
    }
    return myExps;
  }, [myExperiences]);

  // const calculateTotalExperience = (experiences) => {
  //   if (!Array.isArray(experiences) || experiences.length === 0) {
  //     return '';
  //   }

  //   if (experiences[0].currently_working === true) {
  //     return '';
  //   }

  //   let totalMonths = 0;

  //   for (const exp of experiences) {
  //     if (exp.start_month && exp.start_year) {
  //       const startDate = moment()
  //         .set('M', exp.start_month - 1)
  //         .set('Y', exp.start_year);
  //       const endDate = exp.currently_working
  //         ? moment()
  //         : exp.end_month && exp.end_year
  //         ? moment()
  //             .set('M', exp.end_month - 1)
  //             .set('Y', exp.end_year)
  //         : null;

  //       if (endDate) {
  //         totalMonths += endDate.diff(startDate, 'months');
  //       }
  //     }
  //   }

  //   const years = Math.floor(totalMonths / 12);
  //   const months = totalMonths % 12;

  //   if (years === 0 && months === 0) {
  //     return '';
  //   }

  //   const yearLabel = years === 1 ? 'yr' : 'yrs';
  //   const monthLabel = months === 1 ? 'month' : 'months';

  //   if (years > 0 && months > 0) {
  //     return `${years} ${yearLabel} ${months} ${monthLabel}`;
  //   } else if (years > 0) {
  //     return `${years} ${yearLabel}`;
  //   } else {
  //     return `${months} ${monthLabel}`;
  //   }
  // };

  /*
  const calculateTotalExperience = (experiences) => {
    if (!Array.isArray(experiences) || experiences.length === 0) {
      return null;
    }

    const companyName = experiences[0]?.company_name;
    if (!companyName) return null;

    const filteredExperiences = experiences.filter(
      exp => exp.company_name?.toLowerCase() === companyName.toLowerCase()
    );

    let totalMonths = 0;

    for (const exp of filteredExperiences) {
      if (exp.start_month && exp.start_year) {
        const startDate = moment()
          .set('M', exp.start_month - 1)
          .set('Y', exp.start_year);
        const endDate = exp.currently_working
          ? moment()
          : exp.end_month && exp.end_year
          ? moment()
              .set('M', exp.end_month - 1)
              .set('Y', exp.end_year)
          : null;

        if (endDate) {
          totalMonths += endDate.diff(startDate, 'months');
        }
      }
    }

    if (totalMonths === 0) {
      return null; 
    }

    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    const yearLabel = years === 1 ? 'yr' : 'yrs';
    const monthLabel = months === 1 ? 'month' : 'months';

    if (years > 0 && months > 0) {
      return `${years} ${yearLabel} ${months} ${monthLabel}`;
    } else if (years > 0) {
      return `${years} ${yearLabel}`;
    } else if (months > 0) {
      return `${months} ${monthLabel}`;
    } else {
      return null;
    }
  };
  */

  const calculateTotalExperience = (experiences) => {
    if (!Array.isArray(experiences) || experiences.length === 0) {
      return null;
    }

    const intervals = [];
    for (const exp of experiences) {
      const startYear = parseInt(exp.start_year);
      const startMonth = parseInt(exp.start_month);
      
      if (startYear) {
        // Treat 0 or invalid months as January (0 in moment)
        const sMonth = Math.max(1, startMonth || 1);
        const startDate = moment([startYear, sMonth - 1, 1]).startOf('month');
        
        let endDate;
        if (exp.currently_working) {
          endDate = moment().endOf('month');
        } else {
          const endYear = parseInt(exp.end_year);
          const endMonth = parseInt(exp.end_month);
          if (endYear) {
            const eMonth = Math.max(1, endMonth || 12);
            endDate = moment([endYear, eMonth - 1, 1]).endOf('month');
          }
        }
        
        if (startDate && endDate && endDate.isAfter(startDate)) {
          intervals.push({ start: startDate, end: endDate });
        }
      }
    }

    if (intervals.length === 0) return null;

    // Merge overlapping intervals
    intervals.sort((a, b) => a.start.diff(b.start));
    const merged = [];
    let current = intervals[0];
    for (let i = 1; i < intervals.length; i++) {
      const next = intervals[i];
      if (next.start.isBefore(current.end) || next.start.isSame(current.end)) {
        current.end = moment.max(current.end, next.end);
      } else {
        merged.push(current);
        current = next;
      }
    }
    merged.push(current);

    let totalMonths = 0;
    for (const interval of merged) {
      // We use diff in months and add 1 to count both start and end months as part of the duration
      totalMonths += Math.max(0, interval.end.diff(interval.start, 'months')) + 1;
    }

    if (totalMonths === 0) return null;

    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    const yearLabel = years === 1 ? 'yr' : 'yrs';
    const monthLabel = months === 1 ? 'month' : 'months';

    const parts = [];
    if (years > 0) parts.push(`${years} ${yearLabel}`);
    if (months > 0) parts.push(`${months} ${monthLabel}`);

    return parts.join(' ');
  };



  const Item = React.memo(({
    exp,
    hasBar = false,
    isLast = false,
    hasTitle = false,
    expArr,
  }) => {

    return (
      <Stack spacing={0} pt={hasTitle ? 4 : 0} pos="relative">
        {hasBar ? (
          <>
            <Box
              pos="absolute"
              w="20px"
              h="20px"
              top={4}
              left={'-40px'}
              bg="brandGray.300"
              borderRadius="full"
              zIndex={1}
            />
            <Box
              pos="absolute"
              w="1"
              top={4}
              bottom={-4}
              left={-8}
              bg="brandGray.300"
            />
          </>
        ) : isLast ? (
          <Box
            pos="absolute"
            w="20px"
            h="20px"
            top={4}
            left={'-40px'}
            bg="brandGray.300"
            borderRadius="full"
            zIndex={1}
          />
        ) : (
          ''
        )}
        <HStack alignItems="flex-start">
          <Stack spacing={0} flex={1}>
            {hasTitle && exp?.title ? <Text>{exp?.title}</Text> : ''}
            <Box fontSize="sm">
              {exp?.start_month !== undefined && exp?.start_year ? (
                <Text display="inline">
                  {moment([parseInt(exp.start_year), Math.max(0, (parseInt(exp.start_month) || 1) - 1), 1]).format('MMMM YYYY')}
                </Text>
              ) : (
                ''
              )}
              {exp?.currently_working ? (
                <Text display="inline"> - Present</Text>
              ) : exp?.end_month !== undefined && exp?.end_year ? (
                <Text display="inline">
                  {' - '}
                  {moment([parseInt(exp.end_year), Math.max(0, (parseInt(exp.end_month) || 1) - 1), 1]).format('MMMM YYYY')}
                </Text>
              ) : (
                ''
              )}
              {exp?.location?.length ? (
                <>
                  <Text display="inline">&nbsp;·&nbsp;</Text>
                  <Text display="inline">{exp?.location}</Text>
                </>
              ) : (
                ''
              )}
            </Box>
            <HStack alignItems="center">
              <Box fontSize="sm" color="#868585">
                {formatCommaSeparated(
                  [
                    exp?.industry,
                    EMPLOYMENT_CHOICES?.find(
                      (ec) => ec.value === exp?.employment_type
                    )?.label,
                  ],
                  ' · '
                )}
              </Box>
              {calculateTotalExperience(expArr) && (
                <>
                  <Text color="#868585" fontSize="2xl">
                    ·
                  </Text>
                  <Text fontSize="sm" color="#868585">
                    {calculateTotalExperience(expArr)}
                  </Text>
                </>
              )}
            </HStack>
            <Stack py={2}>
              {exp?.desc ? <SeeMore text={exp?.desc} /> : ''}
            </Stack>
          </Stack>
          {hasTitle ? (
            <HStack>
              <Tooltip label={renderPermissionSwitch(exp?.audience)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(exp?.audience)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    audienceDisc.onOpen();
                    setPermissionValue('experience');
                    setCurrentPermissionValue(exp?.audience);
                    setPermissionId(exp?.id);
                  }}
                />
              </Tooltip>
              <Tooltip label="Edit">
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={onEditClick(exp)}
                />
              </Tooltip>
            </HStack>
          ) : (
            ''
          )}
        </HStack>
      </Stack>
    );
  });

  return (
    <>
      {experienceDisc?.isOpen ? (
        <MyProfileExperienceModal nonModal noHeadline />
      ) : (
        <Stack ref={sectionRef}>
          <HStack alignItems="flex-start">
            <Stack flex={1}>
              <Heading
                fontSize="18px"
                color="brandPrimary.500"
                fontWeight="400"
              >
                {t('profileExperience.experience') || "Experience"}
              </Heading>
            </Stack>
            <HStack justifyContent="flex-end">
              {Object.values(groupedExperiences ?? {})?.length && (
                <IconButton
                  leftIcon={<AddIcon color="#868585" />}
                  variant="transparent"
                  size={['sm', 'md']}
                  color="brandPrimary.500"
                  onClick={(e) => experienceDisc?.onOpen?.()}
                  ml="40%"
                />
              )}
            </HStack>
          </HStack>
          {Object.values(groupedExperiences ?? {})?.length ? (
            <>
              <Stack pt={4} spacing={6}>
                {Object.values(groupedExperiences)
                  ?.filter?.((_, ind) => showAll || ind < 3)
                  ?.map?.((expArr, expIndex) => {
                    const exp = expArr?.[0];
                    return (
                      <Stack key={expIndex}>
                        <HStack key={expIndex} alignItems="flex-start">
                          <Avatar size="md" name={exp?.company_name} />
                          <Stack spacing={0} flex={1}>
                            <Box>
                              {expArr?.length <= 1 ? (
                                <Text display="inline">
                                  {exp?.title ? exp?.title : ''}
                                  {expArr?.length <= 1 ? ' at ' : ''}
                                </Text>
                              ) : (
                                ''
                              )}
                              <Text display="inline" fontWeight="600">
                                {exp?.company_name}
                              </Text>
                            </Box>
                            {expArr.length <= 1 ? (
                              ''
                            ) : (
                              <HStack alignItems="center">
                                <Box fontSize="sm" color="#868585">
                                  {formatCommaSeparated(
                                    [
                                      exp?.industry,
                                      EMPLOYMENT_CHOICES?.find(
                                        (ec) =>
                                          ec.value === exp?.employment_type
                                      )?.label,
                                    ],
                                    ' · '
                                  )}
                                </Box>
                                {/* <Text color="#868585" fontSize="2xl">
                                  ·
                                </Text>
                                <Text fontSize="sm" color="#868585">
                                  {calculateTotalExperience(expArr)}
                                </Text> */}
                                {calculateTotalExperience(expArr) && (
                                  <>
                                    <Text color="#868585" fontSize="2xl">
                                      ·
                                    </Text>
                                    <Text fontSize="sm" color="#868585">
                                      {calculateTotalExperience(expArr)}
                                    </Text>
                                  </>
                                )}
                              </HStack>
                            )}
                            {expArr.length <= 1 ? (
                              <Item exp={exp} key={expIndex} expArr={expArr} />
                            ) : (
                              <Stack spacing={0} mt={6}>
                                {expArr.map((exp_, expIndex_) => (
                                  <Item
                                    hasTitle={true}
                                    hasBar={expIndex_ < expArr.length - 1}
                                    exp={exp_}
                                    key={expIndex_}
                                    isLast={expIndex_ === expArr.length - 1}
                                    // expArr={expArr}
                                  />
                                ))}
                              </Stack>
                            )}
                          </Stack>
                          {expArr.length <= 1 ? (
                            <HStack>
                              <Tooltip
                                label={
                                  renderPermissionSwitch(exp?.audience)?.text
                                }
                              >
                                <IconButton
                                  icon={
                                    renderPermissionSwitch(exp?.audience)?.icon
                                  }
                                  size="sm"
                                  variant="transparent"
                                  onClick={() => {
                                    audienceDisc.onOpen();
                                    setPermissionValue('experience');
                                    setCurrentPermissionValue(exp?.audience);
                                    setPermissionId(exp?.id);
                                  }}
                                />
                              </Tooltip>
                              <Tooltip label={t('buttons.edit') || "Edit"}>
                                <IconButton
                                  icon={<EditIcon width="16px" height="16px" />}
                                  size="sm"
                                  variant="transparent"
                                  onClick={onEditClick(exp)}
                                />
                              </Tooltip>
                            </HStack>
                          ) : (
                            ''
                          )}
                        </HStack>
                        {Object.values(groupedExperiences ?? {})?.length > 1 &&
                        expIndex <
                          Object.values(groupedExperiences ?? {})?.length -
                            1 ? (
                          <Divider />
                        ) : (
                          ''
                        )}
                      </Stack>
                    );
                  })}
              </Stack>
              {!showAll && Object.values(groupedExperiences)?.length > 3 ? (
                <ShowAllLink onClick={(e) => setShowAll(true)} />
              ) : (
                ''
              )}
            </>
          ) : (
            <>
              <HStack justifyContent="flex-start">
                {isMobile&&(<Button
                  leftIcon={null} // Remove the default positioning of the icon
                  width="100%" // Adjust to desired width; fit-content will limit its flexibility
                  justifyContent="space-between" // Ensure icon moves to the end
                  variant="transparent"
                  color={isMobile ? '#747474' : 'brandPrimary.500'}
                  onClick={(e) => experienceDisc?.onOpen?.()}
                  pl={0}
                >
                  <Box opacity={0.5}>{t('profileDetails.addLocation') || 'Add location'}</Box>
                  <NewPlusIcon width="20" height="20" />
                </Button>)}
                {!isMobile&&(<Button
                  leftIcon={<AddCircleFIlled />}
                  variant="transparent"
                  color="brandPrimary.500"
                  onClick={(e) => experienceDisc?.onOpen?.()}
                  pl={0}
                >
                  {t('profile.addExperience') || 'Add Experience'}
                </Button>)}
              </HStack>
            </>
          )}
        </Stack>
      )}
    </>
  );
}));
